export default __webpack_public_path__ + "static/cafeterabg1_6-cda98376304bd528fd32e093de21f88d.png";